import * as Icon from "ubs-icons";
import {isElectron} from "ubs-framework/v2/common/function";

export const LIMIT = {
    TOAST_TIME_OUT: 5000,
};
export const REGEX = {
    number: /\d/, // /^(?=.*?[0-9])/
    upperCase: /[A-Z]/, // /^(?=.*?[A-Z])/
    lowerCase: /[a-z]/, // /^(?=.*?[a-z])/
    specialChar: /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/,
}
export const constant = {
    COOKIE_DAYS: 90,
    TOAST_TIME_OUT: 5000,
    mobileViewPort: 576,
    iPadViewPort: 768,
    iPadLandscapePort: 1024,
    PLATFORM: isElectron() ? 'electron' : 'web',
    EMP_COUNT: [
        {label: "1-5", value: "1-5"},
        {label: "5-25", value: "5-25"},
        {label: "25-50", value: "25-50"},
        {label: "50-100", value: "50-100"},
        {label: "100-500", value: "100-500"},
        {label: "500-1000", value: "500-1000"},
        {label: "1000+", value: "1000+"}
    ],
    EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,5}$/i,
    DESPOSABLE_EMAIL: [
        "0x01.gq",
        "0x01.tk",
        "10mail.org",
        "10mail.tk",
        "33m.co",
        "33mail.com",
        "3dxtras.com",
        "3utilities.com",
        "567map.xyz",
        "8191.at",
        "aa.am",
        "accountsite.me",
        "acmetoy.com",
        "acusupply.com",
        "adultvidlite.com",
        "aji.kr",
        "anonaddy.com",
        "anonaddy.me",
        "anonbox.net",
        "anyalias.com",
        "asanatest1.us",
        "azzawajalla.store",
        "bajetesik.store",
        "band-freier.de",
        "bandband1.com",
        "bangmadid.store",
        "batikbantul.com",
        "bccto.me",
        "bebekpenyet.buzz",
        "bei.kr",
        "bel.kr",
        "beo.kr",
        "bfo.kr",
        "bgsaddrmwn.me",
        "bho.kr",
        "biasaelho.space",
        "biz.st",
        "biz.tm",
        "bko.kr",
        "blacksong.pw",
        "blueauramassage.com",
        "bounceme.net",
        "bum.net",
        "buwosok.tech",
        "buzzndaraiangop2wae.buzz",
        "byui.me",
        "caboodle.buzz",
        "cad.edu.gr",
        "cempue.online",
        "chickenkiller.com",
        "choirul.host",
        "cid.kr",
        "ciran.xyz",
        "cko.kr",
        "cloudns.asia",
        "cloudns.cc",
        "cloudns.cx",
        "cloudns.nz",
        "com.com",
        "coms.hk",
        "comx.cf",
        "craigslist.org",
        "creo.site",
        "creo.tips",
        "creou.dev",
        "crowdpress.it",
        "cu.cc",
        "cua77.xyz",
        "d3vs.net",
        "dadosa.xyz",
        "danuarte.online",
        "darrels.site",
        "daseus.online",
        "dayatan.host",
        "dbo.kr",
        "ddns.net",
        "ddnsfree.com",
        "deail.com",
        "dedyn.io",
        "defaultdomain.ml",
        "discard-email.cf",
        "dko.kr",
        "dlink.cf",
        "dlink.gq",
        "dlyemail.com",
        "dmtc.dev",
        "dmtc.edu.pl",
        "dmtc.press",
        "dns-cloud.net",
        "dns.navy",
        "dnsabr.com",
        "dnses.ro",
        "doy.kr",
        "drope.ml",
        "dropmail.me",
        "dynu.net",
        "dzalaev-advokat.ru",
        "e4ward.com",
        "ediantenan.site",
        "edu.auction",
        "efo.kr",
        "eho.kr",
        "ely.kr",
        "email-temp.com",
        "emailfake.com",
        "emailfake.ml",
        "emailfreedom.ml",
        "emlhub.com",
        "emlpro.com",
        "emltmp.com",
        "emy.kr",
        "enu.kr",
        "eny.kr",
        "epizy.com",
        "escritossad.net",
        "ese.kr",
        "esy.es",
        "ewa.kr",
        "exi.kr",
        "ezyro.com",
        "fackme.gq",
        "fassagforpresident.ga",
        "firste.ml",
        "flu.cc",
        "foy.kr",
        "fr.nf",
        "freeml.net",
        "gadzooks.buzz",
        "gettrials.com",
        "giize.com",
        "gmail.gr.com",
        "gmeil.me",
        "gok.kr",
        "gotdns.ch",
        "gpa.lu",
        "grigio.cf",
        "guardmail.cf",
        "haddo.eu",
        "heliohost.org",
        "higogoya.com",
        "historial.store",
        "hitechinfo.com",
        "hix.kr",
        "hiz.kr",
        "hmail.us",
        "hopto.org",
        "hostingarif.me",
        "idn.vn",
        "iesco.info",
        "igg.biz",
        "ignorelist.com",
        "iki.kr",
        "ilovemyniggers.club",
        "imouto.pro",
        "info.tm",
        "infos.st",
        "irr.kr",
        "isgre.at",
        "it2-mail.tk",
        "jil.kr",
        "jindmail.club",
        "jto.kr",
        "junnuok.com",
        "justemail.ml",
        "kadokawa.top",
        "kantal.buzz",
        "keitin.site",
        "kentel.buzz",
        "kerl.cf",
        "kerl.gq",
        "kikwet.com",
        "kondomeus.site",
        "kozow.com",
        "kranjingan.store",
        "kranjingan.tech",
        "kranjingans.tech",
        "kro.kr",
        "lal.kr",
        "laste.ml",
        "lbe.kr",
        "legundi.site",
        "lei.kr",
        "likevip.net",
        "liopers.link",
        "lko.co.kr",
        "lko.kr",
        "ll47.net",
        "lofteone.ru",
        "lom.kr",
        "longdz.site",
        "longmusic.com",
        "lostandalone.com",
        "loudcannabisapp.com",
        "loy.kr",
        "loyalherceghalom.ml",
        "luk2.com",
        "luksarcenter.ru",
        "luo.kr",
        "lyrics-lagu.me",
        "mail-temp.com",
        "mail0.ga",
        "mailinator.com",
        "mailr.eu",
        "marrone.cf",
        "mbe.kr",
        "mblimbingan.space",
        "mebelnovation.ru",
        "mefound.com",
        "mintemail.com",
        "mishmash.buzz",
        "mko.kr",
        "mlo.kr",
        "mooo.com",
        "motifasidiri.website",
        "mp-j.cf",
        "mp-j.ga",
        "mp-j.gq",
        "mp-j.ml",
        "mp-j.tk",
        "mr-meshkat.com",
        "mrossi.cf",
        "mrossi.gq",
        "mrossi.ml",
        "ms1.email",
        "msdc.co",
        "muabanwin.net",
        "museumplanet.com",
        "my.id",
        "my3mail.cf",
        "my3mail.ga",
        "my3mail.gq",
        "my3mail.ml",
        "my3mail.tk",
        "myddns.me",
        "myeslbookclub.com",
        "mymy.cf",
        "mysafe.ml",
        "mzon.store",
        "n-e.kr",
        "nafko.cf",
        "nctu.me",
        "netmail.tk",
        "netricity.nl",
        "new-mgmt.ga",
        "ngalasmoen.xyz",
        "ngguwokulon.online",
        "njambon.space",
        "nko.kr",
        "now.im",
        "npv.kr",
        "nuo.co.kr",
        "nuo.kr",
        "nut.cc",
        "o-r.kr",
        "oazis.site",
        "obo.kr",
        "ocry.com",
        "office.gy",
        "okezone.bid",
        "one.pl",
        "onlysext.com",
        "oovy.org",
        "oppoesrt.online",
        "orangotango.ml",
        "otherinbox.com",
        "ourhobby.com",
        "owa.kr",
        "owh.ooo",
        "oyu.kr",
        "p-e.kr",
        "pafnuty.com",
        "pandies.space",
        "paqeh.online",
        "pe.hu",
        "petinggiean.tech",
        "peyekkolipi.buzz",
        "poderosamulher.com",
        "poistaa.com",
        "porco.cf",
        "poy.kr",
        "prapto.host",
        "probatelawarizona.com",
        "ptcu.dev",
        "pubgm.website",
        "qbi.kr",
        "qc.to",
        "r-e.kr",
        "ragel.me",
        "rao.kr",
        "reilis.site",
        "rf.gd",
        "ringen.host",
        "rko.kr",
        "rosso.ml",
        "row.kr",
        "rr.nu",
        "rshagor.xyz",
        "s-ly.me",
        "safe-mail.gq",
        "sagun.info",
        "samsueng.site",
        "saucent.online",
        "sborra.tk",
        "schwarzmail.ga",
        "seluang.com",
        "sempak.link",
        "sendaljepit.site",
        "sendangagung.online",
        "servegame.com",
        "shp7.cn",
        "siambretta.com",
        "skodaauto.cf",
        "soju.buzz",
        "solidplai.us",
        "somee.com",
        "spamtrap.ro",
        "spymail.one",
        "ssanphone.me",
        "standeight.com",
        "statuspage.ga",
        "steakbeef.site",
        "stonedogdigital.com",
        "stop-my-spam.pp.ua",
        "storeyee.com",
        "sumanan.site",
        "supere.ml",
        "svblog.com",
        "sytes.net",
        "tandy.co",
        "tangtingtung.tech",
        "teml.net",
        "tempembus.buzz",
        "tempremail.cf",
        "tempremail.tk",
        "tgwrzqr.top",
        "thepieter.com",
        "theworkpc.com",
        "thinktimessolve.info",
        "thumoi.com",
        "tko.co.kr",
        "tko.kr",
        "tmo.kr",
        "tmpeml.com",
        "toh.info",
        "toi.kr",
        "tomcrusenono.host",
        "topikurrohman.xyz",
        "tourbalitravel.com",
        "traveldesk.com",
        "tricakesi.store",
        "trillianpro.com",
        "twilightparadox.com",
        "tyrex.cf",
        "uha.kr",
        "uk.to",
        "uko.kr",
        "umy.kr",
        "unaux.com",
        "undo.it",
        "uny.kr",
        "uola.org",
        "upy.kr",
        "urbanban.com",
        "us.to",
        "usa.cc",
        "uu.gl",
        "uvy.kr",
        "uyu.kr",
        "vay.kr",
        "vba.kr",
        "veo.kr",
        "viola.gq",
        "vivoheroes.xyz",
        "vkbags.in",
        "vo.uk",
        "volvo-xc.tk",
        "vuforia.us",
        "wakultimbo.buzz",
        "web.id",
        "weprof.it",
        "werkuldino.buzz",
        "wil.kr",
        "wingkobabat.buzz",
        "x24hr.com",
        "xiaomie.store",
        "xo.uk",
        "xxi2.com",
        "yarien.eu",
        "yawahid.host",
        "ye.vc",
        "yertxenor.tk",
        "yomail.info",
        "yopmail.com",
        "yoqoyyum.space",
        "youdontcare.com",
        "zalvisual.us",
        "zapto.org",
        "ze.cx",
        "zeroe.ml"
    ],
    COUNTRY_CODE: [
        {"name": "Afghanistan", "label": "Afghanistan", "dial_code": "+93", "code": "AF"},
        {"name": "Aland Islands", "label": "Aland Islands", "dial_code": "+358", "code": "AX"},
        {"name": "Albania", "label": "Albania", "dial_code": "+355", "code": "AL"},
        {"name": "Algeria", "label": "Algeria", "dial_code": "+213", "code": "DZ"},
        {"name": "Canada", "label": "Canada", "dial_code": "+1", "code": "CA"},
        {"name": "AmericanSamoa", "label": "AmericanSamoa", "dial_code": "+1684", "code": "AS"},
        {"name": "Andorra", "label": "Andorra", "dial_code": "+376", "code": "AD"},
        {"name": "Angola", "label": "Angola", "dial_code": "+244", "code": "AO"},
        {"name": "Anguilla", "label": "Anguilla", "dial_code": "+1264", "code": "AI"},
        {"name": "Antarctica", "label": "Antarctica", "dial_code": "+672", "code": "AQ"},
        {"name": "Antigua and Barbuda", "label": "Antigua and Barbuda", "dial_code": "+1268", "code": "AG"},
        {"name": "Argentina", "label": "Argentina", "dial_code": "+54", "code": "AR"},
        {"name": "Armenia", "label": "Armenia", "dial_code": "+374", "code": "AM"},
        {"name": "Aruba", "label": "Aruba", "dial_code": "+297", "code": "AW"},
        {"name": "Australia", "label": "Australia", "dial_code": "+61", "code": "AU"},
        {"name": "Austria", "label": "Austria", "dial_code": "+43", "code": "AT"},
        {"name": "Azerbaijan", "label": "Azerbaijan", "dial_code": "+994", "code": "AZ"},
        {"name": "Bahamas", "label": "Bahamas", "dial_code": "+1242", "code": "BS"},
        {"name": "Bahrain", "label": "Bahrain", "dial_code": "+973", "code": "BH"},
        {"name": "Bangladesh", "label": "Bangladesh", "dial_code": "+880", "code": "BD"},
        {"name": "Barbados", "label": "Barbados", "dial_code": "+1246", "code": "BB"},
        {"name": "Belarus", "label": "Belarus", "dial_code": "+375", "code": "BY"},
        {"name": "Belgium", "label": "Belgium", "dial_code": "+32", "code": "BE"},
        {"name": "Belize", "label": "Belize", "dial_code": "+501", "code": "BZ"},
        {"name": "Benin", "label": "Benin", "dial_code": "+229", "code": "BJ"},
        {"name": "Bermuda", "label": "Bermuda", "dial_code": "+1441", "code": "BM"},
        {"name": "Bhutan", "label": "Bhutan", "dial_code": "+975", "code": "BT"},
        {
            "name": "Bolivia, Plurinational State of",
            "label": "Bolivia, Plurinational State of",
            "dial_code": "+591",
            "code": "BO"
        },
        {"name": "Bosnia and Herzegovina", "label": "Bosnia and Herzegovina", "dial_code": "+387", "code": "BA"},
        {"name": "Botswana", "label": "Botswana", "dial_code": "+267", "code": "BW"},
        {"name": "Brazil", "label": "Brazil", "dial_code": "+55", "code": "BR"},
        {
            "name": "British Indian Ocean Territory",
            "label": "British Indian Ocean Territory",
            "dial_code": "+246",
            "code": "IO"
        },
        {"name": "Brunei Darussalam", "label": "Brunei Darussalam", "dial_code": "+673", "code": "BN"},
        {"name": "Bulgaria", "label": "Bulgaria", "dial_code": "+359", "code": "BG"},
        {"name": "Burkina Faso", "label": "Burkina Faso", "dial_code": "+226", "code": "BF"},
        {"name": "Burundi", "label": "Burundi", "dial_code": "+257", "code": "BI"},
        {"name": "Cambodia", "label": "Cambodia", "dial_code": "+855", "code": "KH"},
        {"name": "Cameroon", "label": "Cameroon", "dial_code": "+237", "code": "CM"},

        {"name": "Cape Verde", "label": "Cape Verde", "dial_code": "+238", "code": "CV"},
        {"name": "Cayman Islands", "label": "Cayman Islands", "dial_code": "+ 345", "code": "KY"},
        {"name": "Central African Republic", "label": "Central African Republic", "dial_code": "+236", "code": "CF"},
        {"name": "Chad", "label": "Chad", "dial_code": "+235", "code": "TD"},
        {"name": "Chile", "label": "Chile", "dial_code": "+56", "code": "CL"},
        {"name": "China", "label": "China", "dial_code": "+86", "code": "CN"},
        {"name": "Christmas Island", "label": "Christmas Island", "dial_code": "+61", "code": "CX"},
        {"name": "Cocos (Keeling) Islands", "label": "Cocos (Keeling) Islands", "dial_code": "+61", "code": "CC"},
        {"name": "Colombia", "label": "Colombia", "dial_code": "+57", "code": "CO"},
        {"name": "Comoros", "label": "Comoros", "dial_code": "+269", "code": "KM"},
        {"name": "Congo", "label": "Congo", "dial_code": "+242", "code": "CG"},
        {
            "name": "Congo, The Democratic Republic of the Congo",
            "label": "Congo, The Democratic Republic of the Congo",
            "dial_code": "+243",
            "code": "CD"
        },
        {"name": "Cook Islands", "label": "Cook Islands", "dial_code": "+682", "code": "CK"},
        {"name": "Costa Rica", "label": "Costa Rica", "dial_code": "+506", "code": "CR"},
        {"name": "Cote d'Ivoire", "label": "Cote d'Ivoire", "dial_code": "+225", "code": "CI"},
        {"name": "Croatia", "label": "Croatia", "dial_code": "+385", "code": "HR"},
        {"name": "Cuba", "label": "Cuba", "dial_code": "+53", "code": "CU"},
        {"name": "Cyprus", "label": "Cyprus", "dial_code": "+357", "code": "CY"},
        {"name": "Czech Republic", "label": "Czech Republic", "dial_code": "+420", "code": "CZ"},
        {"name": "Denmark", "label": "Denmark", "dial_code": "+45", "code": "DK"},
        {"name": "Djibouti", "label": "Djibouti", "dial_code": "+253", "code": "DJ"},
        {"name": "Dominica", "label": "Dominica", "dial_code": "+1767", "code": "DM"},
        {"name": "Dominican Republic", "label": "Dominican Republic", "dial_code": "+1849", "code": "DO"},
        {"name": "Ecuador", "label": "Ecuador", "dial_code": "+593", "code": "EC"},
        {"name": "Egypt", "label": "Egypt", "dial_code": "+20", "code": "EG"},
        {"name": "El Salvador", "label": "El Salvador", "dial_code": "+503", "code": "SV"},
        {"name": "Equatorial Guinea", "label": "Equatorial Guinea", "dial_code": "+240", "code": "GQ"},
        {"name": "Eritrea", "label": "Eritrea", "dial_code": "+291", "code": "ER"},
        {"name": "Estonia", "label": "Estonia", "dial_code": "+372", "code": "EE"},
        {"name": "Ethiopia", "label": "Ethiopia", "dial_code": "+251", "code": "ET"},
        {
            "name": "Falkland Islands (Malvinas)",
            "label": "Falkland Islands (Malvinas)",
            "dial_code": "+500",
            "code": "FK"
        },
        {"name": "Faroe Islands", "label": "Faroe Islands", "dial_code": "+298", "code": "FO"},
        {"name": "Fiji", "label": "Fiji", "dial_code": "+679", "code": "FJ"},
        {"name": "Finland", "label": "Finland", "dial_code": "+358", "code": "FI"},
        {"name": "France", "label": "France", "dial_code": "+33", "code": "FR"},
        {"name": "French Guiana", "label": "French Guiana", "dial_code": "+594", "code": "GF"},
        {"name": "French Polynesia", "label": "French Polynesia", "dial_code": "+689", "code": "PF"},
        {"name": "Gabon", "label": "Gabon", "dial_code": "+241", "code": "GA"},
        {"name": "Gambia", "label": "Gambia", "dial_code": "+220", "code": "GM"},
        {"name": "Georgia", "label": "Georgia", "dial_code": "+995", "code": "GE"},
        {"name": "Germany", "label": "Germany", "dial_code": "+49", "code": "DE"},
        {"name": "Ghana", "label": "Ghana", "dial_code": "+233", "code": "GH"},
        {"name": "Gibraltar", "label": "Gibraltar", "dial_code": "+350", "code": "GI"},
        {"name": "Greece", "label": "Greece", "dial_code": "+30", "code": "GR"},
        {"name": "Greenland", "label": "Greenland", "dial_code": "+299", "code": "GL"},
        {"name": "Grenada", "label": "Grenada", "dial_code": "+1473", "code": "GD"},
        {"name": "Guadeloupe", "label": "Guadeloupe", "dial_code": "+590", "code": "GP"},
        {"name": "Guam", "label": "Guam", "dial_code": "+1671", "code": "GU"},
        {"name": "Guatemala", "label": "Guatemala", "dial_code": "+502", "code": "GT"},
        {"name": "Guernsey", "label": "Guernsey", "dial_code": "+44", "code": "GG"},
        {"name": "Guinea", "label": "Guinea", "dial_code": "+224", "code": "GN"},
        {"name": "Guinea-Bissau", "label": "Guinea-Bissau", "dial_code": "+245", "code": "GW"},
        {"name": "Guyana", "label": "Guyana", "dial_code": "+595", "code": "GY"},
        {"name": "Haiti", "label": "Haiti", "dial_code": "+509", "code": "HT"},
        {
            "name": "Holy See (Vatican City State)",
            "label": "Holy See (Vatican City State)",
            "dial_code": "+379",
            "code": "VA"
        },
        {"name": "Honduras", "label": "Honduras", "dial_code": "+504", "code": "HN"},
        {"name": "Hong Kong", "label": "Hong Kong", "dial_code": "+852", "code": "HK"},
        {"name": "Hungary", "label": "Hungary", "dial_code": "+36", "code": "HU"},
        {"name": "Iceland", "label": "Iceland", "dial_code": "+354", "code": "IS"},
        {"name": "India", "label": "India", "dial_code": "+91", "code": "IN"},
        {"name": "Indonesia", "label": "Indonesia", "dial_code": "+62", "code": "ID"},
        {
            "name": "Iran, Islamic Republic of Persian Gulf",
            "label": "Iran, Islamic Republic of Persian Gulf",
            "dial_code": "+98",
            "code": "IR"
        },
        {"name": "Iraq", "label": "Iraq", "dial_code": "+964", "code": "IQ"},
        {"name": "Ireland", "label": "Ireland", "dial_code": "+353", "code": "IE"},
        {"name": "Isle of Man", "label": "Isle of Man", "dial_code": "+44", "code": "IM"},
        {"name": "Israel", "label": "Israel", "dial_code": "+972", "code": "IL"},
        {"name": "Italy", "label": "Italy", "dial_code": "+39", "code": "IT"},
        {"name": "Jamaica", "label": "Jamaica", "dial_code": "+1876", "code": "JM"},
        {"name": "Japan", "label": "Japan", "dial_code": "+81", "code": "JP"},
        {"name": "Jersey", "label": "Jersey", "dial_code": "+44", "code": "JE"},
        {"name": "Jordan", "label": "Jordan", "dial_code": "+962", "code": "JO"},
        {"name": "Kazakhstan", "label": "Kazakhstan", "dial_code": "+77", "code": "KZ"},
        {"name": "Kenya", "label": "Kenya", "dial_code": "+254", "code": "KE"},
        {"name": "Kiribati", "label": "Kiribati", "dial_code": "+686", "code": "KI"},
        {
            "name": "Korea, Democratic People's Republic of Korea",
            "label": "Korea, Democratic People's Republic of Korea",
            "dial_code": "+850",
            "code": "KP"
        },
        {
            "name": "Korea, Republic of South Korea",
            "label": "Korea, Republic of South Korea",
            "dial_code": "+82",
            "code": "KR"
        },
        {"name": "Kuwait", "label": "Kuwait", "dial_code": "+965", "code": "KW"},
        {"name": "Kyrgyzstan", "label": "Kyrgyzstan", "dial_code": "+996", "code": "KG"},
        {"name": "Laos", "label": "Laos", "dial_code": "+856", "code": "LA"},
        {"name": "Latvia", "label": "Latvia", "dial_code": "+371", "code": "LV"},
        {"name": "Lebanon", "label": "Lebanon", "dial_code": "+961", "code": "LB"},
        {"name": "Lesotho", "label": "Lesotho", "dial_code": "+266", "code": "LS"},
        {"name": "Liberia", "label": "Liberia", "dial_code": "+231", "code": "LR"},
        {"name": "Libyan Arab Jamahiriya", "label": "Libyan Arab Jamahiriya", "dial_code": "+218", "code": "LY"},
        {"name": "Liechtenstein", "label": "Liechtenstein", "dial_code": "+423", "code": "LI"},
        {"name": "Lithuania", "label": "Lithuania", "dial_code": "+370", "code": "LT"},
        {"name": "Luxembourg", "label": "Luxembourg", "dial_code": "+352", "code": "LU"},
        {"name": "Macao", "label": "Macao", "dial_code": "+853", "code": "MO"},
        {"name": "Macedonia", "label": "Macedonia", "dial_code": "+389", "code": "MK"},
        {"name": "Madagascar", "label": "Madagascar", "dial_code": "+261", "code": "MG"},
        {"name": "Malawi", "label": "Malawi", "dial_code": "+265", "code": "MW"},
        {"name": "Malaysia", "label": "Malaysia", "dial_code": "+60", "code": "MY"},
        {"name": "Maldives", "label": "Maldives", "dial_code": "+960", "code": "MV"},
        {"name": "Mali", "label": "Mali", "dial_code": "+223", "code": "ML"},
        {"name": "Malta", "label": "Malta", "dial_code": "+356", "code": "MT"},
        {"name": "Marshall Islands", "label": "Marshall Islands", "dial_code": "+692", "code": "MH"},
        {"name": "Martinique", "label": "Martinique", "dial_code": "+596", "code": "MQ"},
        {"name": "Mauritania", "label": "Mauritania", "dial_code": "+222", "code": "MR"},
        {"name": "Mauritius", "label": "Mauritius", "dial_code": "+230", "code": "MU"},
        {"name": "Mayotte", "label": "Mayotte", "dial_code": "+262", "code": "YT"},
        {"name": "Mexico", "label": "Mexico", "dial_code": "+52", "code": "MX"},
        {
            "name": "Micronesia, Federated States of Micronesia",
            "label": "Micronesia, Federated States of Micronesia",
            "dial_code": "+691",
            "code": "FM"
        },
        {"name": "Moldova", "label": "Moldova", "dial_code": "+373", "code": "MD"},
        {"name": "Monaco", "label": "Monaco", "dial_code": "+377", "code": "MC"},
        {"name": "Mongolia", "label": "Mongolia", "dial_code": "+976", "code": "MN"},
        {"name": "Montenegro", "label": "Montenegro", "dial_code": "+382", "code": "ME"},
        {"name": "Montserrat", "label": "Montserrat", "dial_code": "+1664", "code": "MS"},
        {"name": "Morocco", "label": "Morocco", "dial_code": "+212", "code": "MA"},
        {"name": "Mozambique", "label": "Mozambique", "dial_code": "+258", "code": "MZ"},
        {"name": "Myanmar", "label": "Myanmar", "dial_code": "+95", "code": "MM"},
        {"name": "Namibia", "label": "Namibia", "dial_code": "+264", "code": "NA"},
        {"name": "Nauru", "label": "Nauru", "dial_code": "+674", "code": "NR"},
        {"name": "Nepal", "label": "Nepal", "dial_code": "+977", "code": "NP"},
        {"name": "Netherlands", "label": "Netherlands", "dial_code": "+31", "code": "NL"},
        {"name": "Netherlands Antilles", "label": "Netherlands Antilles", "dial_code": "+599", "code": "AN"},
        {"name": "New Caledonia", "label": "New Caledonia", "dial_code": "+687", "code": "NC"},
        {"name": "New Zealand", "label": "New Zealand", "dial_code": "+64", "code": "NZ"},
        {"name": "Nicaragua", "label": "Nicaragua", "dial_code": "+505", "code": "NI"},
        {"name": "Niger", "label": "Niger", "dial_code": "+227", "code": "NE"},
        {"name": "Nigeria", "label": "Nigeria", "dial_code": "+234", "code": "NG"},
        {"name": "Niue", "label": "Niue", "dial_code": "+683", "code": "NU"},
        {"name": "Norfolk Island", "label": "Norfolk Island", "dial_code": "+672", "code": "NF"},
        {"name": "Northern Mariana Islands", "label": "Northern Mariana Islands", "dial_code": "+1670", "code": "MP"},
        {"name": "Norway", "label": "Norway", "dial_code": "+47", "code": "NO"},
        {"name": "Oman", "label": "Oman", "dial_code": "+968", "code": "OM"},
        {"name": "Pakistan", "label": "Pakistan", "dial_code": "+92", "code": "PK"},
        {"name": "Palau", "label": "Palau", "dial_code": "+680", "code": "PW"},
        {
            "name": "Palestinian Territory, Occupied",
            "label": "Palestinian Territory, Occupied",
            "dial_code": "+970",
            "code": "PS"
        },
        {"name": "Panama", "label": "Panama", "dial_code": "+507", "code": "PA"},
        {"name": "Papua New Guinea", "label": "Papua New Guinea", "dial_code": "+675", "code": "PG"},
        {"name": "Paraguay", "label": "Paraguay", "dial_code": "+595", "code": "PY"},
        {"name": "Peru", "label": "Peru", "dial_code": "+51", "code": "PE"},
        {"name": "Philippines", "label": "Philippines", "dial_code": "+63", "code": "PH"},
        {"name": "Pitcairn", "label": "Pitcairn", "dial_code": "+872", "code": "PN"},
        {"name": "Poland", "label": "Poland", "dial_code": "+48", "code": "PL"},
        {"name": "Portugal", "label": "Portugal", "dial_code": "+351", "code": "PT"},
        {"name": "Puerto Rico", "label": "Puerto Rico", "dial_code": "+1939", "code": "PR"},
        {"name": "Qatar", "label": "Qatar", "dial_code": "+974", "code": "QA"},
        {"name": "Romania", "label": "Romania", "dial_code": "+40", "code": "RO"},
        {"name": "Russia", "label": "Russia", "dial_code": "+7", "code": "RU"},
        {"name": "Rwanda", "label": "Rwanda", "dial_code": "+250", "code": "RW"},
        {"name": "Reunion", "label": "Reunion", "dial_code": "+262", "code": "RE"},
        {"name": "Saint Barthelemy", "label": "Saint Barthelemy", "dial_code": "+590", "code": "BL"},
        {
            "name": "Saint Helena, Ascension and Tristan Da Cunha",
            "label": "Saint Helena, Ascension and Tristan Da Cunha",
            "dial_code": "+290",
            "code": "SH"
        },
        {"name": "Saint Kitts and Nevis", "label": "Saint Kitts and Nevis", "dial_code": "+1869", "code": "KN"},
        {"name": "Saint Lucia", "label": "Saint Lucia", "dial_code": "+1758", "code": "LC"},
        {"name": "Saint Martin", "label": "Saint Martin", "dial_code": "+590", "code": "MF"},
        {"name": "Saint Pierre and Miquelon", "label": "Saint Pierre and Miquelon", "dial_code": "+508", "code": "PM"},
        {
            "name": "Saint Vincent and the Grenadines",
            "label": "Saint Vincent and the Grenadines",
            "dial_code": "+1784",
            "code": "VC"
        },
        {"name": "Samoa", "label": "Samoa", "dial_code": "+685", "code": "WS"},
        {"name": "San Marino", "label": "San Marino", "dial_code": "+378", "code": "SM"},
        {"name": "Sao Tome and Principe", "label": "Sao Tome and Principe", "dial_code": "+239", "code": "ST"},
        {"name": "Saudi Arabia", "label": "Saudi Arabia", "dial_code": "+966", "code": "SA"},
        {"name": "Senegal", "label": "Senegal", "dial_code": "+221", "code": "SN"},
        {"name": "Serbia", "label": "Serbia", "dial_code": "+381", "code": "RS"},
        {"name": "Seychelles", "label": "Seychelles", "dial_code": "+248", "code": "SC"},
        {"name": "Sierra Leone", "label": "Sierra Leone", "dial_code": "+232", "code": "SL"},
        {"name": "Singapore", "label": "Singapore", "dial_code": "+65", "code": "SG"},
        {"name": "Slovakia", "label": "Slovakia", "dial_code": "+421", "code": "SK"},
        {"name": "Slovenia", "label": "Slovenia", "dial_code": "+386", "code": "SI"},
        {"name": "Solomon Islands", "label": "Solomon Islands", "dial_code": "+677", "code": "SB"},
        {"name": "Somalia", "label": "Somalia", "dial_code": "+252", "code": "SO"},
        {"name": "South Africa", "label": "South Africa", "dial_code": "+27", "code": "ZA"},
        {"name": "South Sudan", "label": "South Sudan", "dial_code": "+211", "code": "SS"},
        {
            "name": "South Georgia and the South Sandwich Islands",
            "label": "South Georgia and the South Sandwich Islands",
            "dial_code": "+500",
            "code": "GS"
        },
        {"name": "Spain", "label": "Spain", "dial_code": "+34", "code": "ES"},
        {"name": "Sri Lanka", "label": "Sri Lanka", "dial_code": "+94", "code": "LK"},
        {"name": "Sudan", "label": "Sudan", "dial_code": "+249", "code": "SD"},
        {"name": "Suriname", "label": "Suriname", "dial_code": "+597", "code": "SR"},
        {"name": "Svalbard and Jan Mayen", "label": "Svalbard and Jan Mayen", "dial_code": "+47", "code": "SJ"},
        {"name": "Swaziland", "label": "Swaziland", "dial_code": "+268", "code": "SZ"},
        {"name": "Sweden", "label": "Sweden", "dial_code": "+46", "code": "SE"},
        {"name": "Switzerland", "label": "Switzerland", "dial_code": "+41", "code": "CH"},
        {"name": "Syrian Arab Republic", "label": "Syrian Arab Republic", "dial_code": "+963", "code": "SY"},
        {"name": "Taiwan", "label": "Taiwan", "dial_code": "+886", "code": "TW"},
        {"name": "Tajikistan", "label": "Tajikistan", "dial_code": "+992", "code": "TJ"},
        {
            "name": "Tanzania, United Republic of Tanzania",
            "label": "Tanzania, United Republic of Tanzania",
            "dial_code": "+255",
            "code": "TZ"
        },
        {"name": "Thailand", "label": "Thailand", "dial_code": "+66", "code": "TH"},
        {"name": "Timor-Leste", "label": "Timor-Leste", "dial_code": "+670", "code": "TL"},
        {"name": "Togo", "label": "Togo", "dial_code": "+228", "code": "TG"},
        {"name": "Tokelau", "label": "Tokelau", "dial_code": "+690", "code": "TK"},
        {"name": "Tonga", "label": "Tonga", "dial_code": "+676", "code": "TO"},
        {"name": "Trinidad and Tobago", "label": "Trinidad and Tobago", "dial_code": "+1868", "code": "TT"},
        {"name": "Tunisia", "label": "Tunisia", "dial_code": "+216", "code": "TN"},
        {"name": "Turkey", "label": "Turkey", "dial_code": "+90", "code": "TR"},
        {"name": "Turkmenistan", "label": "Turkmenistan", "dial_code": "+993", "code": "TM"},
        {"name": "Turks and Caicos Islands", "label": "Turks and Caicos Islands", "dial_code": "+1649", "code": "TC"},
        {"name": "Tuvalu", "label": "Tuvalu", "dial_code": "+688", "code": "TV"},
        {"name": "Uganda", "label": "Uganda", "dial_code": "+256", "code": "UG"},
        {"name": "Ukraine", "label": "Ukraine", "dial_code": "+380", "code": "UA"},
        {"name": "United Arab Emirates", "label": "United Arab Emirates", "dial_code": "+971", "code": "AE"},
        {"name": "United Kingdom", "label": "United Kingdom", "dial_code": "+44", "code": "GB"},
        {"name": "United States", "label": "United States", "dial_code": "+1", "code": "US"},
        {"name": "Uruguay", "label": "Uruguay", "dial_code": "+598", "code": "UY"},
        {"name": "Uzbekistan", "label": "Uzbekistan", "dial_code": "+998", "code": "UZ"},
        {"name": "Vanuatu", "label": "Vanuatu", "dial_code": "+678", "code": "VU"},
        {
            "name": "Venezuela, Bolivarian Republic of Venezuela",
            "label": "Venezuela, Bolivarian Republic of Venezuela",
            "dial_code": "+58",
            "code": "VE"
        },
        {"name": "Vietnam", "label": "Vietnam", "dial_code": "+84", "code": "VN"},
        {"name": "Virgin Islands, British", "label": "Virgin Islands, British", "dial_code": "+1284", "code": "VG"},
        {"name": "Virgin Islands, U.S.", "label": "Virgin Islands, U.S.", "dial_code": "+1340", "code": "VI"},
        {"name": "Wallis and Futuna", "label": "Wallis and Futuna", "dial_code": "+681", "code": "WF"},
        {"name": "Yemen", "label": "Yemen", "dial_code": "+967", "code": "YE"},
        {"name": "Zambia", "label": "Zambia", "dial_code": "+260", "code": "ZM"},
        {"name": "Zimbabwe", "label": "Zimbabwe", "dial_code": "+263", "code": "ZW"}
    ],
    COUNTRIES: ['Afghanistan', 'land Islands', 'Albania', 'Algeria', 'American Samoa', 'AndorrA', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo, The Democratic Republic of the', 'Cook Islands', 'Costa Rica', 'Cote D\'Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands (Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard Island and Mcdonald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran, Islamic Republic Of', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, Democratic People\'S Republic of', 'Korea, Republic of', 'Kuwait', 'Kyrgyzstan', 'Lao People\'S Democratic Republic', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libyan Arab Jamahiriya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 'Macedonia, The Former Yugoslav Republic of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States of', 'Moldova, Republic of', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestinian Territory, Occupied', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russian Federation', 'RWANDA', 'Saint Helena', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Pierre and Miquelon', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia and the South Sandwich Islands', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic', 'Taiwan, Province of China', 'Tajikistan', 'Tanzania, United Republic of', 'Thailand', 'Timor-Leste', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela', 'Viet Nam', 'Virgin Islands, British', 'Virgin Islands, U.S.', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe',],

};

export const COLOR = {
    u_title: '#1e2538',
    u_font: '#73788b',
    u_icon_bg: '#4E525F',
    u_white: '#FFFFFF',
    u_blue: '#007AFF',
    u_orange: '#FFA700',
    u_green: '#60B158',
    u_pastelred: '#FF6961',
}

// Purpose options
export const PURPOSE_OPTIONS = [
    { label: "Work", value: 1 },
    { label: "Personal", value: 2 },
    { label: "School", value: 3 },
    { label: "Other", value: 4 },
];

// Source options
export const SOURCE_OPTIONS = [
    { label: "Software Review Sites", value: 1 },
    { label: "Google", value: 2 },
    { label: "YouTube", value: 3 },
    { label: "LinkedIn", value: 4 },
    { label: "Facebook", value: 5 },
    { label: "Instagram", value: 6 },
    { label: "Friend / Colleague", value: 7 },
    { label: "Other", value: 8 },
];

export const MANAGE_OPTIONS = [
    { label: "Software Development", value: 1 },
    { label: "Startup", value: 2 },
    { label: "Finance & Accounting", value: 3 },
    { label: "Creative & Design", value: 4 },
    { label: "IT", value: 5 },
    { label: "PMO", value: 6 },
    { label: "Support", value: 7 },
    { label: "Personal Use", value: 8 },
    { label: "Sales & CRM", value: 9 },
    { label: "Operations", value: 10 },
    { label: "Professional Services", value: 11 },
    { label: "Marketing", value: 12 },
    { label: "HR & Recruiting", value: 13 },
    { label: "Other", value: 14 },
];

export const TEAM_SIZE_OPTIONS = [
    { label: "Only me", value: 1 },
    { label: "2-5", value: 2 },
    { label: "6-10", value: 3 },
    { label: "11-15", value: 4 },
    { label: "16-25", value: 5 },
    { label: "26-50", value: 6 },
    { label: "51-100", value: 7 },
    { label: "101-500", value: 8 },
    { label: "500+", value: 9 },
];

export const TOOL_OPTIONS = [
    { label: "Monday.com", value: 1 },
    { label: "Salesforce", value: 2 },
    { label: "Confluence", value: 3 },
    { label: "MS Teams", value: 4 },
    { label: "Workable", value: 5 },
    { label: "Basecamp", value: 6 },
    { label: "Zoho", value: 7 },
    { label: "Todoist", value: 8 },
    { label: "Wrike", value: 9 },
    { label: "Slack", value: 10 },
    { label: "Kredily", value: 11 },
    { label: "Asana", value: 12 },
    { label: "Trello", value: 13 },
    { label: "Notion", value: 14 },
    { label: "Keka", value: 15 },
    { label: "GreayHR", value: 16 },
    { label: "Smart HR", value: 17 },
    { label: "Clickup", value: 18 },
    { label: "Kissflow", value: 19 },
    { label: "HROne", value: 20 },
    { label: "None of the above", value: 21 },
];

export const SIGNUP_STEPS = {
    1: 'verify-otp',
    2: 'company-details',
    3: 'company-other-info',
    4: 'building',
}

export const SLUG_TYPE = {
    SUPERTRACK: 'track'
}

export const SLUG_TYPE_PRODUCT = [SLUG_TYPE?.SUPERTRACK]

export const GOAL_OPTIONS = [
    { id: 1, label: "Employee Attendance", desc: "Manage your Employee Attendance smoothly", icon: "" },
    { id: 2, label: "Employee Leave", desc: "Track and manage employee leave requests", icon: "" },
    { id: 3, label: "Payroll Management", desc: "Streamline your payroll processing", icon: "" },
    { id: 4, label: "Performance Review", desc: "Conduct effective performance evaluations", icon: "" },
    { id: 5, label: "Recruitment", desc: "Manage hiring process efficiently", icon: "" },
    { id: 6, label: "Employee Onboarding", desc: "Smooth onboarding experience for new hires", icon: "" },
];

export const CONFIGURATION_TYPE = {
    REGISTRATION_STEPS: 'registrationSteps',
}


export const INVOICE_SETTING_TYPE  = [
    {value: 1, label: 'Billing Name'},
    {value: 2, label: 'Sub-company Wise'},
];

export const SUBSCRIPTION_STATUS = {
    'INITIATED': 1,
    'INITIALIZED': 2,
    'BANK_APPROVAL_PENDING': 3,
    'ACTIVE': 4,
    'ON_HOLD': 5,
    'PAUSED': 6,
    'CUSTOMER_PAUSED': 7,
    'CANCELLED': 8,
    'CUSTOMER_CANCELLED': 9,
    'EXPIRED': 10,
    'LINK_EXPIRED': 11,
    'CARD_EXPIRED': 12,
    'COMPLETED': 13,
    'FAILED': 14,
}

export const BILLING_CYCLE = {
    MONTHLY: 'MONTHLY',
    QUARTERLY: 'QUARTERLY',
    YEARLY: 'YEARLY',
}

export const BILLING_CYCLE_OPTIONS = [
    { label: 'Monthly', value: 'MONTHLY' },
    // { label: 'Quarterly', value: 'QUARTERLY' },
    { label: 'Yearly', value: 'YEARLY' },
]

export const PLAN_CURRENCY = [
    { label: 'INR', value: 'INR' },
    { label: 'USD', value: 'USD' },
]

export const PAYMENT_CARD_TYPE = [
    { label: 'Debit Card' , value: 'DEBIT_CARD' },
    { label: 'Credit Card' , value: 'CREDIT_CARD' },
    { label: 'Prepaid' , value: 'PREPAID_CARD' },
    { label: 'Debit Card' , value: 'DEBIT' },
    { label: 'Credit Card' , value: 'CREDIT' },
    { label: 'Prepaid' , value: 'PREPAID' }
]

export const SUBSCRIPTION_STATUS_OPTIONS = [
    { label: 'Initiated', value: 1, color: '#999999' },
    { label: 'Initialized', value: 2, color: '#999999' },
    { label: 'Bank Approval Pending', value: 3, color: '#FFA700' },
    { label: 'Active', value: 4, color: '#60B158' },
    { label: 'On Hold', value: 5, color: '#FF6961' },
    { label: 'Paused', value: 6, color: '#FFA700' },
    { label: 'Customer Paused', value: 7, color: '#FFA700' },
    { label: 'Cancelled', value: 8, color: '#FF6961' },
    { label: 'Customer Cancelled', value: 9, color: '#FF6961' },
    { label: 'Expired', value: 10, color: '#999999' },
    { label: 'Link Expired', value: 11, color: '#999999' },
    { label: 'Card Expired', value: 12, color: '#999999' },
    { label: 'Completed', value: 13, color: '#60B158' },
    { label: 'Failed', value: 14, color: '#FF6961' },
]

export const INDIA_COUNTRY_IDS = ['629ddeff2ab28d1ab4138db2', '629df31761cce12e3c1599cc', '62b3d5abfe294c21ac253539'];

// API Usage Monitor (Aadhaar & PAN) — migrated from HRMS > Reports
export const ADHAAR_PAN_API_TYPE = {
    ADHAAR_VERIFICATION: 1,
    PAN_VERIFICATION: 2,
    ADHAAR_PAN_LINK: 3,
    WHATSAPP_MARKETING: 4,
    WHATSAPP_UTILITY: 5,
    DOCUMENT_SCAN: 6,
};

export const VERIFICATION_STATUS = [
    { value: 1, label: 'Success', color: '#60B158' },
    { value: 2, label: 'Failed', color: '#FF6961' },
];

// Credit request status options (used by Credit History)
export const STATUS_OPTIONS = [
    { label: 'Pending', status: 'pending', color: '#FFA700', value: 1 },
    { label: 'Approved', status: 'approved', color: '#60B158', value: 2 },
    { label: 'Rejected', status: 'rejected', color: '#FF6961', value: 3 },
    { label: 'Cancelled', status: 'cancelled', color: '#1E2538', value: 4 },
];

export const APP_DISPLAY = {
    HRMS: 'HRMS',
    PAYROLL: 'Payroll',
    PMS: 'Project Management',
    CHAT: 'Super Chat',
    RECRUIT: 'Recruit',
    ASSETS: 'Assets',
    PERFORMANCE: 'Performance',
    LMS: 'LMS',
    TRACK: 'Super Track',
    WORKDIARY: 'Super Track',
    ACCOUNT: 'Account',
    superTrack: 'Super Track',
    superChat: 'Super Chat',
};

export const PLATFORM_TITLE = {
    WEB: 'Browser',
    DESKTOP: 'Desktop',
    MOBILE: 'Mobile',
};

export const PLATFORM_ICON = {
    WEB: Icon.Browser,
    DESKTOP: Icon.Desktop,
    MOBILE: Icon.Mobile,
};

export const ORG_OVERVIEW_USER_IDS = [
    '5f3e0cf283e9801a80bbca0e',
    '67505cba90b74eedbef02f26',
    '5f3d0b8080f11416a24e976d',
    '6756a00d3d66a84164d14939',
];
